import { createSelector } from '@reduxjs/toolkit'

export const selectCameraState = state => state.camera

export const selectCameras = createSelector(selectCameraState, state => state.available || [])

export const selectCameraDevice = createSelector(selectCameraState, state => state.device)

export const selectCameraSettings = createSelector(selectCameraState, state => state.camera_settings)

export const selectFacingMode = createSelector(selectCameraState, state => state.facingMode)

export const selectIsFrontCamera = createSelector(selectFacingMode, facingMode => facingMode === 'user')

export const selectCameraLoading = createSelector(selectCameraState, state => state.loading)

export const selectZoom = createSelector(selectCameraState, state => state.zoom)

export const selectZoomCapability = createSelector(selectCameraState, state => state.zoomCapability)

export const selectCanZoom = createSelector(selectZoomCapability, capability => capability !== null)

export const selectCameraBlocked = createSelector(selectCameraState, state => state.blocked)
